import * as _ from 'lodash';

const RequestMethod = {
    HEAD: 'HEAD',
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE',
};

/**
 * Represent Centralize Ajax Service
 */

const applicationJsonType = 'application/json';

export class RestClientService {
    static singleInstance = null;

    static _singleInstance() {
        return RestClientService.singleInstance || (RestClientService.singleInstance = new RestClientService());
    }

    getUrls = [];

    credentialOptions = null;
    keepCredential = false;

    useCredentials() {
        this.credentialOptions = 'include';
        this.keepCredential = false;
    }

    keepCredentials() {
        this.credentialOptions = 'include';
        this.keepCredential = true;
    }

    request(url, type, data, customHeaders) {
        let headers = {
            'Content-Type': applicationJsonType,
            'Accept': applicationJsonType
        };

        if (customHeaders) {
            headers = _.merge(headers, customHeaders);
        }

        const options = {
            method: type,
            headers: headers
        };

        if (data && headers[ 'Content-Type' ] === applicationJsonType) {
            options.body = JSON.stringify(data);
        }

        if (this.credentialOptions) {
            options.credentials = this.credentialOptions;
            if (!this.keepCredential) {
                this.credentialOptions = null;
            }
        }

        return fetch(url, options)
            .then((response) => {
                if (response.ok) {
                    return response.text();
                }

                return response.json().then(actualResponse => {
                    throw actualResponse;
                });
            })
            .then(response => {
                try {
                    let resultObject = JSON.parse(response);

                    return resultObject || JSON.parse(response);
                } catch (e) {
                    return response;
                }
            });
    }

    head(url) {
        return this.request(url, RequestMethod.HEAD);
    }

    get(url, customHeaders) {
        return this.request(url, RequestMethod.GET, null, customHeaders);
    }

    singleGet(url, customHeaders) {
        const existingRequest = this.getUrls.find(getRequest => getRequest.url === url);
        if (existingRequest) {
            return existingRequest.request;
        }

        const promise = this.request(url, RequestMethod.GET, null, customHeaders).then(response => {
            setTimeout(() => {
                this.getUrls = _.filter(this.getUrls, getRequest => getRequest.url !== url);
            }, 700);

            return response;
        });

        this.getUrls.push({
            url: url,
            request: promise
        });

        return promise;
    }

    post(url, data, customHeaders) {
        return this.request(url, RequestMethod.POST, data, customHeaders);
    }

    put(url, data, customHeaders) {
        return this.request(url, RequestMethod.PUT, data, customHeaders);
    }

    delete(url, customHeaders) {
        return this.request(url, RequestMethod.DELETE, null, customHeaders);
    }
}

const restClientService = RestClientService._singleInstance();

export default restClientService;



// WEBPACK FOOTER //
// ./src/utils/RestClientService.js